import {
  Card,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
} from '@chakra-ui/react';

const Event = ({ data, title, onClick }) => {
  const clickListener = (e) => {
    const type = e.target.className.split(' ')[0];
    if (type === 'hp') {
      const num = e.target.textContent.replace(/,/g, '');
      onClick(type, { hp: num });
    }

    if (type === 'mp') {
      const num = e.target.textContent.replace(/,/g, '');
      onClick(type, { mp: num });
    }

    if (type === 'job') {
      const numHp = e.currentTarget
        .querySelector('.hp')
        .textContent.replace(/,/g, '');
      const numMp = e.currentTarget
        .querySelector('.mp')
        .textContent.replace(/,/g, '');
      onClick('job', { hp: numHp, mp: numMp });
    }
  };
  return (
    <Card m={4} maxW={400} w='100%'>
      <Badge>
        <Text ml={3}>{title}</Text>
      </Badge>
      <TableContainer>
        <Table size='sm'>
          <Thead>
            <Tr>
              <Th>직업</Th>
              <Th>체력</Th>
              <Th>마력</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((e) => {
              return (
                <Tr key={e.k} onClick={clickListener}>
                  <Td className='job'>{e.name}</Td>
                  <Td className='hp'>{e.hp.toLocaleString()}</Td>
                  <Td className='mp'>{e.mp.toLocaleString()}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default Event;
